export const FILE_EXTENSION = {
	'*/*': '*/*',
	'image/*': ['jpg', 'jpeg', 'png', 'gif', 'webp'],
	'application/pdf': ['pdf']
}
